<template>
    <div class="athlete-manage-container">
        <el-card class="main-card" shadow="hover">
            <el-tabs v-model="activeTab" type="border-card" size='small' @tab-click="handleTabsClick">
                <el-tab-pane label="运动员管理" name="athletes">
                    <div class="card-header">
                        <div class="search-area">
                            <el-form :inline="true" :model="athleteSearch" class="search-form">
                                <el-form-item label="姓名">
                                    <el-input v-model="athleteSearch.UserName" size="small"
                                        placeholder="请输入姓名"></el-input>
                                </el-form-item>
                                <el-form-item label="性别">
                                    <el-select v-model="athleteSearch.Gender" size="small" placeholder="请选择性别"
                                        clearable>
                                        <el-option label="男子" value="0"></el-option>
                                        <el-option label="女子" value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="手机号码">
                                    <el-input v-model="athleteSearch.UserPhone" size="small" placeholder="请输入手机号码"
                                        clearable></el-input>
                                </el-form-item>
                                <el-form-item label="分组">
                                    <el-input v-model="athleteSearch.GroupId" size="small" placeholder="请输入分组"
                                        clearable></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button icon="el-icon-search" type="primary" size="small"
                                        @click="searchUnitAthletes">搜索</el-button>
                                    <el-button icon="el-icon-plus" size="small"
                                        @click="handleAddUnitAthlete">添加运动员</el-button>

                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <el-table :data="athleteTable.Data" border size="small"
                        :header-cell-style="{ background: '#FAFAFA' }" stripe>
                        <el-table-column prop="UserName" label="姓名" width="100" align="center"></el-table-column>
                        <el-table-column prop="Gender" label="性别" width="80" align="center">
                            <template #default="scope">
                                <span v-if="scope.row.Gender == 0">男子</span>
                                <span v-else>女子</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Age" label="年龄" width="70" align="center"></el-table-column>
                        <el-table-column prop="IdentityCard" label="身份证号码" width="150" align="center"></el-table-column>
                        <el-table-column prop="Birthday" label="出生年月" width="100" align="center">
                            <template v-slot="scope">
                                {{ formatDateTime(scope.row.Birthday) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="UserPhone" label="手机号码" width="120" align="center"></el-table-column>
                        <el-table-column prop="GroupId" label="分组" width="120" align="center"></el-table-column>
                        <el-table-column prop="EnrollmentNum" label="学籍号" width="150" align="center"></el-table-column>
                        <el-table-column prop="Grade" label="年级" width="100" align="center"></el-table-column>
                        <el-table-column prop="Remarks" label="备注" align="center"></el-table-column>
                        <el-table-column label="操作" align="center" width="150">
                            <template #default="scope">
                                <el-button size="small" @click="handleEditUnitAthlete(scope.row)">编辑</el-button>
                                <el-button size="small" type="danger"
                                    @click="handleDeleteRow('athlete', scope.row.AthleteId)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="text-align: right;">
                        <el-pagination background layout="total, prev, pager, next, jumper"
                            :total="athleteTable.TotalRow" :page-size="athleteTable.PageSize"
                            :current-page="athleteTable.PageIndex" @size-change="handleAthleteTableSizeChange"
                            @current-change="handleAthleteTableCurrentChange"></el-pagination>
                    </div>


                </el-tab-pane>

                <el-tab-pane label="随队人员管理" name="staff">
                    <div class="card-header">
                        <div class="search-area">
                            <el-form :inline="true" :model="staffSearch" class="search-form">
                                <el-form-item label="姓名">
                                    <el-input v-model="staffSearch.StaffName" size="small" placeholder="请输入姓名"
                                        clearable></el-input>
                                </el-form-item>
                                <el-form-item label="性别">
                                    <el-select v-model="staffSearch.Gender" size="small" placeholder="请选择性别" clearable>
                                        <el-option label="男子" value="0"></el-option>
                                        <el-option label="女子" value="1"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="手机号码">
                                    <el-input v-model="staffSearch.StaffPhone" size="small" placeholder="请输入手机号码"
                                        clearable></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button icon="el-icon-search" type="primary" size="small"
                                        @click="searchUnitStaffs">搜索</el-button>
                                    <el-button icon="el-icon-plus" @click="handleAddStaff"
                                        size="small">添加随队人员</el-button>

                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <el-table :data="staffTable.Data" border style="width: 100%" size="small"
                        :header-cell-style="{ background: '#FAFAFA' }" stripe>
                        <el-table-column prop="StaffName" label="姓名" width="150" align="center"></el-table-column>
                        <el-table-column prop="Gender" label="性别" width="100" align="center">
                            <template #default="scope">
                                <span v-if="scope.row.Gender == 0">男子</span>
                                <span v-else>女子</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Age" label="年龄" width="100" align="center"></el-table-column>
                        <!-- <el-table-column prop="IdCardType" label="证件类型" width="120"></el-table-column> -->
                        <el-table-column prop="IdentityCard" label="身份证号码" width="150" align="center"></el-table-column>
                        <el-table-column prop="Birthday" label="出生日期" width="120" align="center">
                            <template v-slot="scope">
                                {{ formatDateTime(scope.row.Birthday) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="StaffPhone" label="手机号码" width="150" align="center"></el-table-column>
                        <el-table-column prop="Post" label="身份" width="120" align="center"></el-table-column>
                        <el-table-column prop="Remarks" label="备注" width="240" align="center"></el-table-column>
                        <el-table-column label="操作" align="center">
                            <template #default="scope">
                                <el-button size="small" @click="handleEditStaff(scope.row)">编辑</el-button>
                                <el-button size="small" type="danger"
                                    @click="handleDeleteRow('team_leader', scope.row.TeamLeaderId)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="text-align: right;">
                        <el-pagination background layout="total, prev, pager, next, jumper" :total="staffTable.TotalRow"
                            :page-size="staffTable.PageSize" :current-page="staffTable.PageIndex"
                            @size-change="handleStaffTableSizeChange"
                            @current-change="handleStaffTableCurrentChange"></el-pagination>
                    </div>
                </el-tab-pane>

                <el-tab-pane label="团队管理" name="teams">
                    <div class="card-header">
                        <div class="search-area">
                            <el-form :inline="true" :model="teamSearch" class="search-form">
                                <el-form-item label="团队名称">
                                    <el-input v-model="teamSearch.TeamName" size="small" placeholder="请输入团队名称"
                                        clearable></el-input>
                                </el-form-item>

                                <el-form-item>
                                    <el-button icon="el-icon-search" type="primary" @click="searchUnitTeams"
                                        size='small' class="search-btn">搜索</el-button>
                                    <el-button icon="el-icon-plus" @click="handleAddTeam" size='small'>添加团队</el-button>
                                </el-form-item>
                            </el-form>

                        </div>

                    </div>
                    <el-table :data="teamTable.Data" border style="width: 100%" size="small"
                        :header-cell-style="{ background: '#FAFAFA' }" stripe>
                        <el-table-column prop="TeamName" label="团队名称" width="250" align="center"></el-table-column>
                        <el-table-column prop="AthleteNames" label="运动员姓名" width="250" align="center"></el-table-column>
                        <!-- <el-table-column prop="genderComposition" label="性别" width="150" align="center">
                            <template #default="scope">
                                <span v-if="scope.row.TeamGender == 0">男子组</span>
                                <span v-if="scope.row.TeamGender == 1">女子组</span>
                                <span v-if="scope.row.TeamGender == 2">男女混合</span>
                            </template>
                        </el-table-column> -->
                        <el-table-column prop="TeamPeopleNumber" label="团队人数" width="100"
                            align="center"></el-table-column>

                        <el-table-column prop="TeamBoyPeopleNumber" label="男生人数" width="100"
                            align="center"></el-table-column>
                        <el-table-column prop="TeamGirlPeopleNumber" label="女生人数" width="100"
                            align="center"></el-table-column>
                        <el-table-column prop="Remarks" label="备注"  align="center"></el-table-column>
                        <el-table-column label="操作" align="center" width="150">
                            <template #default="scope">
                                <el-button size="small" @click="handleEditTeam(scope.row)">编辑</el-button>
                                <el-button size="small" type="danger"
                                    @click="handleDeleteRow('team', scope.row.TeamId)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="text-align: right;">
                        <el-pagination background layout="total, prev, pager, next, jumper" :total="teamTable.TotalRow"
                            :page-size="teamTable.PageSize" :current-page="teamTable.PageIndex"
                            @size-change="handleTeamTableSizeChange"
                            @current-change="handleTeamTableCurrentChange"></el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>

        </el-card>

        <!-- 运动员添加/编辑对话框 -->
        <el-dialog :title="dialogType === 'add' ? '添加运动员' : '编辑运动员'" :visible.sync="athleteDialogVisible" width="1200px"
            :close-on-click-modal="false">
            <el-form :model="athleteForm" :rules="athleteRules" ref="athleteFormRef" label-width="130px"
                style="width: 95%;margin: 0 auto;">
                <el-row :gutter="30">
                    <el-col :span="12">
                        <el-form-item label="姓名" prop="UserName">
                            <el-input v-model="athleteForm.UserName" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="性别" prop="Gender">
                            <el-radio-group v-model="athleteForm.Gender">
                                <el-radio :label="0">男子</el-radio>
                                <el-radio :label="1">女子</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="出生年月" prop="Birthday">
                            <el-date-picker v-model="athleteForm.Birthday" type="date" placeholder="请选择出生年月"
                                style="width: 100%">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="身份证号码" prop="IdentityCard">
                            <el-input v-model="athleteForm.IdentityCard" placeholder="请输入证件号码"></el-input>
                        </el-form-item>

                        <el-form-item label="学籍号">
                            <el-input v-model="athleteForm.EnrollmentNum" placeholder="运动员为学生必填，报名时需要"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号码">
                            <el-input v-model="athleteForm.UserPhone" placeholder="请输入手机号码"></el-input>
                        </el-form-item>
                        <el-form-item label="分组">
                            <el-input v-model="athleteForm.GroupId" placeholder="请输入分组"></el-input>
                        </el-form-item>


                        <el-form-item label="年级" prop="Grade">
                            <el-select v-model="athleteForm.Grade">
                                <el-option v-for="item in gradeOptions" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="备注">
                            <el-input type="textarea" v-model="athleteForm.Remarks" placeholder="请输入手机号码"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="个人照片" prop="photo" class="upload-item">
                            <div v-if="athleteForm.UserPhotoFileId" class="avatar-uploader">
                                <div class="image-delete" @click.stop="handleDeleteImage('athletePhoto')">
                                    <i class="el-icon-delete"></i>
                                </div>
                                <el-image class="avatar" style="height: 100%; width: auto;"
                                    :src="fileRootPath + athleteForm.UserPhotoFilePath"
                                    :preview-src-list="[fileRootPath + athleteForm.UserPhotoFilePath]">
                                </el-image>
                            </div>
                            <div v-if="!athleteForm.UserPhotoFileId">
                                <el-upload class="avatar-uploader" action="#" ref="athletePhotoUploadRef"
                                    accept=".jpg,.png,.jpeg" :http-request="(file) => uploadFile(file, 'athletePhoto')"
                                    :show-file-list="false" :before-upload="beforePhotoUpload">
                                    <div class="upload-placeholder">
                                        <i class="el-icon-plus"></i>

                                    </div>

                                </el-upload>

                            </div>
                        </el-form-item>
                        <el-form-item label="证件类型">
                            <el-radio-group v-model="athleteForm.IdCardType">
                                <el-radio :label="0">身份证</el-radio>
                                <el-radio :label="1">户口本</el-radio>
                                <el-radio :label="2">其他</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="证件图片" prop="idCardImage" class="upload-item">
                            <div v-if="athleteForm.IdCardFileId" class="id-card-uploader">
                                <div class="image-delete" @click.stop="handleDeleteImage('athleteIdCard')">
                                    <i class="el-icon-delete"></i>
                                </div>
                                <el-image style="height: 100%; width: auto;"
                                    :src="fileRootPath + athleteForm.IdCardFilePath"
                                    :preview-src-list="[fileRootPath + athleteForm.IdCardFilePath]">
                                </el-image>
                            </div>
                            <div v-if="!athleteForm.IdCardFileId">
                                <el-upload class="id-card-uploader" action="#" accept=".jpg,.png,.jpeg"
                                    ref="athleteIdCardUploadRef"
                                    :http-request="(file) => uploadFile(file, 'athleteIdCard')" :show-file-list="false"
                                    :before-upload="beforeIdCardUpload">
                                    <div class="upload-placeholder">
                                        <i class="el-icon-plus"></i>
                                    </div>
                                </el-upload>
                            </div>
                        </el-form-item>
                        <el-form-item label="学籍图片" prop="idCardImage" class="upload-item">
                            <div v-if="athleteForm.EnrollmentFileId" class="id-card-uploader">
                                <div class="image-delete" @click.stop="handleDeleteImage('athleteEnrollment')">
                                    <i class="el-icon-delete"></i>
                                </div>
                                <el-image style="height: 100%; width: auto;"
                                    :src="fileRootPath + athleteForm.EnrollmentFilePath"
                                    :preview-src-list="[fileRootPath + athleteForm.EnrollmentFilePath]">
                                </el-image>
                            </div>
                            <div v-if="!athleteForm.EnrollmentFileId">
                                <el-upload class="id-card-uploader" action="#" accept=".jpg,.png,.jpeg"
                                    ref="athleteEnrollmentUploadRef"
                                    :http-request="(file) => uploadFile(file, 'athleteEnrollment')"
                                    :show-file-list="false" :before-upload="beforeEnrollmentUpload">
                                    <div class="upload-placeholder">
                                        <i class="el-icon-plus"></i>
                                    </div>
                                </el-upload>

                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="athleteDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="submitAthleteForm">确 定</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 随队人员添加/编辑对话框 -->
        <el-dialog :title="dialogType === 'add' ? '添加随队人员' : '编辑随队人员'" :visible.sync="staffDialogVisible" width="800px"
            :close-on-click-modal="false">
            <el-form :model="staffForm" :rules="staffRules" ref="staffFormRef" label-width="100px">



                <el-row :gutter="30">
                    <el-col :span="12">
                        <el-form-item label="姓名" prop="StaffName">
                            <el-input v-model="staffForm.StaffName" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="性别" prop="Gender">
                            <el-radio-group v-model="staffForm.Gender">
                                <el-radio :label="0">男子</el-radio>
                                <el-radio :label="1">女子</el-radio>
                            </el-radio-group>

                        </el-form-item>
                        <el-form-item label="手机号码" prop="StaffPhone">
                            <el-input v-model="staffForm.StaffPhone" placeholder="请输入手机号码"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号码" prop="IdentityCard">
                            <el-input v-model="staffForm.IdentityCard" placeholder="请输入身份证号码"></el-input>
                        </el-form-item>
                        <el-form-item label="出生日期" prop="Birthday">
                            <el-date-picker v-model="staffForm.Birthday" type="date" placeholder="请选择出生日期"
                                style="width: 100%" value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="身份/岗位" prop="Post">
                            <el-select v-model="staffForm.Post">
                                <el-option v-for="post in staffPosts" :label="post" :value="post"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="备注" prop="Remarks">
                            <el-input type='textarea' v-model="staffForm.Remarks"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="个人照片" class="upload-item">

                            <div v-if="staffForm.StaffPhotoFileId" class="avatar-uploader">
                                <div class="image-delete" @click.stop="handleDeleteImage('staffPhoto')">
                                    <i class="el-icon-delete"></i>
                                </div>
                                <el-image class="avatar" style="height: 100%; width: auto;"
                                    :src="fileRootPath + staffForm.StaffPhotoFilePath"
                                    :preview-src-list="[fileRootPath + staffForm.StaffPhotoFilePath]">
                                </el-image>
                            </div>
                            <div v-if="!staffForm.StaffPhotoFileId">
                                <el-upload class="avatar-uploader" action="#" ref="staffPhotoUploadRef"
                                    accept=".jpg,.png,.jpeg" :http-request="(file) => uploadFile(file, 'staffPhoto')"
                                    :show-file-list="false" :before-upload="beforePhotoUpload">
                                    <div class="upload-placeholder">
                                        <i class="el-icon-plus"></i>
                                    </div>
                                </el-upload>
                                <div class="el-upload__tip">
                                    请上传JPG/PNG格式照片，不超过2MB
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="证件类型">
                            <el-select v-model="staffForm.IdCardType" placeholder="请选择证件类型" style="width: 100%">
                                <el-option label="身份证" :value="0"></el-option>
                                <el-option label="户口本" :value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="身份证件" class="upload-item">
                            <div v-if="staffForm.IdCardFileId" class="id-card-uploader">
                                <div class="image-delete" @click.stop="handleDeleteImage('staffIdCard')">
                                    <i class="el-icon-delete"></i>
                                </div>
                                <el-image class="avatar" style="height: 100%; width: auto;"
                                    :src="fileRootPath + staffForm.IdCardFilePath"
                                    :preview-src-list="[fileRootPath + staffForm.IdCardFilePath]">
                                </el-image>
                            </div>
                            <div v-if="!staffForm.IdCardFileId">
                                <el-upload class="id-card-uploader" action="#" accept=".jpg,.png,.jpeg"
                                    ref="staffIdCardUploadRef" :http-request="(file) => uploadFile(file, 'staffIdCard')"
                                    :show-file-list="false" :before-upload="beforeIdCardUpload">
                                    <div class="upload-placeholder">
                                        <i class="el-icon-plus"></i>
                                    </div>
                                </el-upload>

                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button size="small" @click="staffDialogVisible = false">取 消</el-button>
                    <el-button size="small" type="primary" @click="submitStaffForm">确 定</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 随队人员添加/编辑对话框 -->
        <el-dialog :title="dialogType === 'add' ? '添加团队' : '编辑团队'" :visible.sync="teamDialogVisible" width="1200px"
            :close-on-click-modal="false">
            <el-form :model="teamForm" :rules="teamRules" ref="teamFormRef" label-width="100px">

                <el-row :gutter="50">
                    <el-col :span="10">
                        <el-form-item label="团队名称" prop="TeamName">
                            <el-input v-model="teamForm.TeamName" placeholder="请输入团队名称"></el-input>
                        </el-form-item>
                         <!-- <el-form-item label="性别" prop="TeamGender">
                            <el-radio-group v-model="teamForm.TeamGender">
                                <el-radio :label="0">男子组</el-radio>
                                <el-radio :label="1">女子组</el-radio>
                                <el-radio :label="2">男女混合</el-radio>
                            </el-radio-group>
                        </el-form-item> -->
                        <el-form-item label="团队照片">
                            <div v-if="teamForm.TeamPhotoFileId" class="avatar-uploader">
                                <div v-if="teamForm.TeamPhotoFileId" class="image-delete"
                                    @click.stop="handleDeleteImage('teamPhoto')">
                                    <i class="el-icon-delete"></i>
                                </div>
                                <el-image class="avatar" style="height: 100%; width: auto;"
                                    :src="fileRootPath + teamForm.TeamPhotoFilePath"
                                    :preview-src-list="[fileRootPath + teamForm.TeamPhotoFilePath]">
                                </el-image>
                            </div>

                            <div v-if="teamForm.TeamPhotoFileId == ''" class="">
                                <el-upload action="#" class="avatar-uploader" ref="teamPhotoUploadRef"
                                    accept=".jpg,.png,.jpeg" :http-request="(file) => uploadFile(file, 'teamPhoto')"
                                    :show-file-list="false" :before-upload="beforePhotoUpload">
                                    <div class="upload-placeholder">
                                        <i class="el-icon-plus"></i>
                                        <span>点击上传</span>
                                    </div>
                                </el-upload>

                            </div>
                        </el-form-item>
                        <el-form-item label="团队备注">
                            <el-input type='textarea' rows='3' v-model="teamForm.Remarks"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="14">
                        <el-transfer :titles="['运动员', '团队人员']" v-model="teamForm.AthleteIdList"
                            :data="athleteList"></el-transfer>
                    </el-col>
                </el-row>

            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button size="small" @click="teamDialogVisible = false">取 消</el-button>
                    <el-button size="small" type="primary" @click="submitTemaForm">确 定</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import contestantServices from '@/request-server/request-services/contestant-services';
import utilsCommon from '@/utils/utils-common';
import SystemService from '@/request-server/request-services/system-services.js';
import Url from '@/request-server/request-url';
import { mapState } from 'vuex';
export default {
    data() {
        return {
            fileRootPath: '',
            activeTab: 'athletes',
            athleteSearch: {
                UserName: '',
                Gender: '',
                UserPhone: '',
                GroupId: ''
            },
            staffSearch: {
                StaffName: '',
                Gender: '',
                StaffPhone: ''
            },
            teamSearch: {
                TeamName: '',
            },
            athleteTable: {
                PageIndex: 1,
                PageSize: 10,
                TotalRow: 0,
                Data: []
            },
            staffTable: {
                PageIndex: 1,
                PageSize: 10,
                TotalRow: 0,
                Data: []
            },
            teamTable: {
                PageIndex: 1,
                PageSize: 10,
                TotalRow: 0,
                Data: []
            },

            // 对话框类型 add 或 edit
            dialogType: 'add',
            // 运动员对话框
            athleteDialogVisible: false,
            athleteForm: {
                AthleteId: '',
                AccountId: '',
                UnitId: '',
                UserName: '',
                Gender: 0,
                Birthday: null,
                IdentityCard: '',
                Age: '',
                UserPhone: '',
                GroupId: '',
                IdCardType: 0,
                IdCardFileId: '',
                UserPhotoFileId: '',
                EnrollmentFileId: '',
                Remarks: '',
                IdCardFilePath: '',
                UserPhotoFilePath: '',
                EnrollmentFilePath: ''
            },
            athleteRules: {
                UserName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                Gender: [
                    { required: true, message: '请选择性别', trigger: 'change' }
                ],
                IdentityCard: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' }
                ],
                Birthday: [
                    { required: true, message: '请输入出生年月', trigger: 'blur' }
                ],
                Grade: [
                    { required: true, message: '请输入年级', trigger: 'blur' }
                ],
            },

            // 随队人员对话框
            staffDialogVisible: false,
            staffForm: {
                TeamLeaderId: '',
                AccountId: '',
                UnitId: '',
                StaffName: '',
                IdCardType: 0,
                IdentityCard: '',
                Gender: 0,
                Birthday: null,
                Age: 0,
                StaffPhone: '',
                Post: '',
                StaffPhotoFileId: '',
                IdCardFileId: '',
                Remarks: '',
                StaffPhotoFilePath: '',
                IdCardFilePath: ''
            },
            staffRules: {
                StaffName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],

                StaffPhone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' }
                ],
                IdentityCard: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' }
                ],
                Birthday: [
                    { required: true, message: '请输入出生年月', trigger: 'blur' }
                ],
                Post: [
                    { required: true, message: '请输入身份', trigger: 'blur' }
                ]
            },
            staffPosts: ['领队', '教练员', '裁判员', '医务', '家长', '嘉宾', '其他'],
            teamDialogVisible: false,
            teamForm: {
                TeamId: '',
                AccountId: '',
                UnitId: '',
                TeamName: '',
                TeamPeopleNumber: 0,
                TeamGender: 0,
                TeamBoyPeopleNumber: 0,
                TeamGirlPeopleNumber: 0,
                AthleteIds: '',
                AthleteIdList: [],
                AthleteNames: '',
                TeamPhotoFileId: '',
                Remarks: ''
            },
            teamRules: {
                TeamName: [
                    { required: true, message: '请输入团队名称', trigger: 'blur' }
                ],
            },
            athleteList: [],
            gradeOptions: [
                { label: '一年级', value: '一年级' },
                { label: '二年级', value: '二年级' },
                { label: '三年级', value: '三年级' },
                { label: '四年级', value: '四年级' },
                { label: '五年级', value: '五年级' },
                { label: '六年级', value: '六年级' },
                { label: '初一', value: '初一' },
                { label: '初二', value: '初二' },
                { label: '初三', value: '初三' },
                { label: '高一', value: '高一' },
                { label: '高二', value: '高二' },
                { label: '高三', value: '高三' },
                { label: '大一', value: '大一' },
                { label: '大二', value: '大二' },
                { label: '大三', value: '大三' },
                { label: '大四', value: '大四' },
                { label: '大五', value: '大五' },
                { label: '研究生', value: '研究生' },
                { label: '其他', value: '其他' },
            ]

        }
    },
    computed: {
        ...mapState({
            unitInfo: state => state.unitInfo
        })
    },
    created() {
        this.fileRootPath = Url.getDownloadBaseUrl() + 'uploadfiles/';
        this.getUnitAthletes();
    },
    methods: {
        handleTabsClick() {
            console.log(this.activeTab)
            if (this.activeTab == 'athletes' && this.athleteTable.Data.length == 0) {
                this.searchUnitAthletes();
            } else if (this.activeTab == 'staff' && this.staffTable.Data.length == 0) {
                this.searchUnitStaffs();
            } else if (this.activeTab == 'teams' && this.teamTable.Data.length == 0) {
                this.searchUnitTeams();
            }
        },
        checkUnit() {
            if (!this.unitInfo.UnitId) {
                this.$confirm('请先完善个人信息?', '提示', {
                    confirmButtonText: '去完善信息',
                    type: 'warning',
                    showClose: false,
                    showCancelButton: false
                }).then(() => {
                    this.$router.replace({ path: '/contestant/personal-center' });
                }).catch(() => {
                    this.$router.replace({ path: '/contestant/personal-center' });
                })

                return false;
            }
            return true;
        },
        initAllAthleteList() {
            let data = {
                PageIndex: 1,
                PageSize: 999999,
                Where: {
                    UserName: '',
                    Gender: '',
                    UserPhone: ''
                }
            }
            this.athleteList = [];
            contestantServices.selectUnitAthletes(data).then(res => {
                console.log(res)
                if (res.code == 0 && res.data.Data) {
                    res.data.Data.forEach(element => {
                        this.athleteList.push({
                            key: element.AthleteId,
                            label: element.UserName + ' ' + (element.Gender == 0 ? '男' : '女') + ' ' + element.Age + '岁 ' + element.Grade
                        })
                    });
                }
            })
        },
        searchUnitAthletes() {
            this.athleteTable.PageIndex = 1;
            this.getUnitAthletes();
        },
        handleAthleteTableSizeChange(size) {
            this.athleteTable.PageSize = size;
            this.getUnitAthletes();
        },
        handleAthleteTableCurrentChange(page) {
            this.athleteTable.PageIndex = page;
            this.getUnitAthletes();
        },
        getUnitAthletes() {
            let data = {
                PageIndex: this.athleteTable.PageIndex,
                PageSize: this.athleteTable.PageSize,
                Where: {
                    UserName: this.athleteSearch.UserName,
                    Gender: this.athleteSearch.Gender,
                    UserPhone: this.athleteSearch.UserPhone,
                    GroupId: this.athleteSearch.GroupId
                }

            }
            this.athleteTable.Data = [];
            contestantServices.selectUnitAthletes(data).then(res => {
                if (res.code == 0) {
                    this.athleteTable.Data = res.data.Data;
                    this.athleteTable.TotalRow = res.data.TotalRow;
                }
            })
        },
        searchUnitStaffs() {
            this.staffTable.PageIndex = 1;
            this.getUnitTeamLeaders();
        },
        handleStaffTableSizeChange(size) {
            this.staffTable.PageSize = size;
            this.getUnitTeamLeaders();
        },
        handleStaffTableCurrentChange(page) {
            this.staffTable.PageIndex = page;
            this.getUnitTeamLeaders();
        },
        getUnitTeamLeaders() {
            let data = {
                PageIndex: this.staffTable.PageIndex,
                PageSize: this.staffTable.PageSize,
                Where: {
                    StaffName: this.staffSearch.StaffName,
                    Gender: this.staffSearch.Gender,
                    StaffPhone: this.staffSearch.StaffPhone
                }

            }
            this.staffTable.Data = [];
            contestantServices.selectUnitTeamLeaders(data).then(res => {
                if (res.code == 0) {
                    this.staffTable.Data = res.data.Data;
                    this.staffTable.TotalRow = res.data.TotalRow;
                }
            })
        },



        searchUnitTeams() {
            this.teamTable.PageIndex = 1;
            this.getUnitTeams();
        },
        getUnitTeams() {
            let data = {
                PageIndex: this.teamTable.PageIndex,
                PageSize: this.teamTable.PageSize,
                Where: {
                    TeamName: this.teamSearch.TeamName,
                }
            }
            contestantServices.selectUnitTeams(data).then(resDate => {
                if (resDate.code == 0) {
                    this.teamTable.Data = resDate.data.Data;
                    this.teamTable.TotalRow = resDate.data.TotalRow;
                }
            })
        },

        handleTeamTableSizeChange(size) {
            this.teamTable.PageSize = size;
            this.getUnitTeams();
        },
        handleTeamTableCurrentChange(page) {
            this.teamTable.PageIndex = page;
            this.getUnitTeams();
        },


        handleAddUnitAthlete() {
            if (this.checkUnit()) {
                this.dialogType = 'add';
                this.resetAthleteForm();
                this.athleteDialogVisible = true;
            }
        },
        handleEditUnitAthlete(row) {
            this.dialogType = 'edit';
            this.resetAthleteForm();
            // 填充表单数据
            this.athleteForm = {
                ...row
            };
            this.athleteForm.Birthday = new Date(row.Birthday);
            console.log(this.athleteForm);
            this.athleteDialogVisible = true;
        },
        resetAthleteForm() {
            this.athleteForm = {
                AthleteId: '',
                UserName: '',
                Gender: 0,
                Birthday: null,
                IdentityCard: '',
                Age: '',
                UserPhone: '',
                IdCardType: 0,
                IdCardFileId: '',
                UserPhotoFileId: '',
                Remarks: '',
                IdCardFilePath: '',
                UserPhotoFilePath: '',
            };
            // 如果表单引用存在，重置验证
            if (this.$refs.athleteFormRef) {
                this.$refs.athleteFormRef.resetFields();
            }
        },
        openFileDialog(fileType, event) {
            console.log(fileType)
            event.stopPropagation();
            if (fileType === 'athletePhoto') {
                this.$refs.athletePhotoUploadRef.$el.querySelector('input[type=file]').click();
            } else if (fileType === 'athleteIdCard') {
                this.$refs.athleteIdCardUploadRef.$el.querySelector('input[type=file]').click();
            } else if (fileType === 'athleteEnrollment') {
                this.$refs.athleteEnrollmentUploadRef.$el.querySelector('input[type=file]').click();
            } else if (fileType == 'staffPhoto') {
                this.$refs.staffPhotoUploadRef.$el.querySelector('input[type=file]').click();
            } else if (fileType === 'staffIdCard') {
                this.$refs.staffIdCardUploadRef.$el.querySelector('input[type=file]').click();
            } else if (fileType == 'teamPhoto') {
                this.$refs.teamPhotoUploadRef.$el.querySelector('input[type=file]').click();
            }
        },
        submitAthleteForm() {
            this.$refs.athleteFormRef.validate(valid => {
                if (valid) {
                    // if (this.athleteForm.IdentityCard == '' && !this.athleteForm.Birthday) {
                    //     this.$message.error('身份证号码与出生日期不能同时为空');
                    //     return;
                    // }

                    // if (this.athleteForm.IdentityCard) {
                    //     // 验证身份证号
                    //     const idCard = this.athleteForm.IdentityCard;
                    //     const idCardReg = /(^\d{15}$)|(^\d{17}([0-9]|X|x)$)/;
                    //     if (!idCardReg.test(idCard)) {
                    //         this.$message.error('请输入有效的身份证号码');
                    //         return false;
                    //     }

                    //     // 通过身份证号解析出生日和年龄
                    //     if (idCard.length === 18) {
                    //         const birthYear = parseInt(idCard.substring(6, 10), 10);
                    //         const birthMonth = parseInt(idCard.substring(10, 12), 10);
                    //         if (birthMonth > 12 || birthMonth == 0) {
                    //             this.$message.error('身份证解析生日月份不合格，值：' + `${birthYear}-${birthMonth}-${birthDay}`);
                    //             return false;
                    //         }
                    //         const birthDay = parseInt(idCard.substring(12, 14), 10);
                    //         if (birthDay > 31 || birthDay == 0) {
                    //             this.$message.error('身份证解析生日月份不合格，值：' + `${birthYear}-${birthMonth}-${birthDay}`);
                    //             return false;
                    //         }
                    //         this.athleteForm.Birthday = `${birthYear}-${birthMonth}-${birthDay}`;

                    //         const currentDate = new Date();
                    //         const currentYear = currentDate.getFullYear();
                    //         const currentMonth = currentDate.getMonth() + 1;
                    //         const currentDay = currentDate.getDate();
                    //         let age = currentYear - birthYear;
                    //         if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
                    //             age--;
                    //         }
                    //         this.athleteForm.Age = age;
                    //     } else if (idCard.length === 15) {
                    //         const birthYear = parseInt('19' + idCard.substring(6, 8), 10);
                    //         const birthMonth = parseInt(idCard.substring(8, 10), 10);
                    //         const birthDay = parseInt(idCard.substring(10, 12), 10);
                    //         this.athleteForm.Birthday = `${birthYear}-${birthMonth}-${birthDay}`;

                    //         const currentDate = new Date();
                    //         const currentYear = currentDate.getFullYear();
                    //         const currentMonth = currentDate.getMonth() + 1;
                    //         const currentDay = currentDate.getDate();
                    //         let age = currentYear - birthYear;
                    //         if (currentMonth < birthMonth || (currentMonth === birthmonth && currentDay < birthDay)) {
                    //             age--;
                    //         }
                    //         this.athleteForm.Age = age;
                    //     }
                    // } else {
                      
                    // }


                    //用生日计算年龄
                    let birthYear = new Date(this.athleteForm.Birthday).getFullYear();
                    let currentYear = new Date().getFullYear();
                    this.athleteForm.Age = currentYear - birthYear;

                    let unit = this.$store.state.unitInfo;
                    if (unit) {
                        this.athleteForm.UnitId = unit.UnitId;
                        this.athleteForm.AccountId = unit.AccountId;
                    }
                    this.athleteForm.Birthday = utilsCommon.formatDate(this.athleteForm.Birthday, 'YYYY/MM/DD HH:mm:ss');
                    if (this.athleteForm.CreateTime) {
                        this.athleteForm.CreateTime = utilsCommon.formatDate(this.athleteForm.CreateTime, 'YYYY/MM/DD HH:mm:ss');
                    }
                    if (this.athleteForm.UpdateTime) {
                        this.athleteForm.UpdateTime = utilsCommon.formatDate(this.athleteForm.UpdateTime, 'YYYY/MM/DD HH:mm:ss');
                    }


                    contestantServices.editUnitAthlete(this.athleteForm).then(resData => {
                        console.log(resData);
                        if (resData.code == 0) {
                            this.$message.success(resData.data);
                            this.athleteDialogVisible = false;
                            this.getUnitAthletes();
                        }
                    });
                } else {
                    this.$message.error('请完善表单信息');
                    return false;
                }
            });
        },
        handleAddStaff() {
            this.dialogType = 'add';
            this.resetStaffForm();
            this.staffDialogVisible = true;
        },
        handleEditStaff(row) {
            this.dialogType = 'edit';
            this.resetStaffForm();
            // 填充表单数据
            this.staffForm = {
                ...row
            };
            this.staffForm.Birthday = new Date(row.Birthday);
            this.staffDialogVisible = true;
        },
        resetStaffForm() {
            this.staffForm = {
                AccountId: '',
                UnitId: '',
                StaffName: '',
                IdCardType: 0,
                IdentityCard: '',
                Gender: 0,
                Birthday: null,
                Age: 0,
                StaffPhone: '',
                Post: '',
                StaffPhotoFileId: '',
                IdCardFileId: '',
                Remarks: '',
                StaffPhotoFilePath: '',
                IdCardFilePath: ''
            };
            // 如果表单引用存在，重置验证
            if (this.$refs.staffFormRef) {
                this.$refs.staffFormRef.resetFields();
            }
        },
        submitStaffForm() {
            this.$refs.staffFormRef.validate(valid => {
                if (valid) {

                    // 验证身份证号
                    // const idCard = this.staffForm.IdentityCard;
                    // const idCardReg = /^(\d{18,18}|\d{15,15}|\d{17,17}x)/;
                    // if (!idCardReg.test(idCard)) {
                    //     this.$message.error('请输入有效的身份证号码');
                    //     return false;
                    // }

                    // // 通过身份证号解析出生日和年龄
                    // if (idCard.length === 18) {
                    //     const birthYear = parseInt(idCard.substring(6, 10), 10);
                    //     const birthMonth = parseInt(idCard.substring(10, 12), 10);
                    //     if (birthMonth > 12 || birthMonth == 0) {
                    //         this.$message.error('身份证解析生日月份不合格，值：' + `${birthYear}-${birthMonth}-${birthDay}`);
                    //         return false;
                    //     }
                    //     const birthDay = parseInt(idCard.substring(12, 14), 10);
                    //     if (birthDay > 31 || birthDay == 0) {
                    //         this.$message.error('身份证解析生日月份不合格，值：' + `${birthYear}-${birthMonth}-${birthDay}`);
                    //         return false;
                    //     }
                    //     this.staffForm.Birthday = `${birthYear}-${birthMonth}-${birthDay}`;

                    //     const currentDate = new Date();
                    //     const currentYear = currentDate.getFullYear();
                    //     const currentMonth = currentDate.getMonth() + 1;
                    //     const currentDay = currentDate.getDate();
                    //     let age = currentYear - birthYear;
                    //     if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
                    //         age--;
                    //     }
                    //     this.staffForm.Age = age;
                    // } else if (idCard.length === 15) {
                    //     const birthYear = parseInt('19' + idCard.substring(6, 8), 10);
                    //     const birthMonth = parseInt(idCard.substring(8, 10), 10);
                    //     const birthDay = parseInt(idCard.substring(10, 12), 10);
                    //     this.staffForm.Birthday = `${birthYear}-${birthMonth}-${birthDay}`;

                    //     const currentDate = new Date();
                    //     const currentYear = currentDate.getFullYear();
                    //     const currentMonth = currentDate.getMonth() + 1;
                    //     const currentDay = currentDate.getDate();
                    //     let age = currentYear - birthYear;
                    //     if (currentMonth < birthmonth && currentDay < birthDay) {
                    //         age--;
                    //     }
                    //     this.staffForm.Age = age;
                    // }

                    let birthYear = new Date(this.staffForm.Birthday).getFullYear();
                    let currentYear = new Date().getFullYear();
                    this.staffForm.Age = currentYear - birthYear;

                    let unit = this.$store.state.unitInfo;
                    if (unit) {
                        this.staffForm.UnitId = unit.UnitId;
                        this.staffForm.AccountId = unit.AccountId;
                    }
                    this.staffForm.Birthday = utilsCommon.formatDate(this.staffForm.Birthday, 'YYYY/MM/DD HH:mm:ss');
                    if (this.staffForm.CreateTime) {
                        this.staffForm.CreateTime = utilsCommon.formatDate(this.staffForm.CreateTime, 'YYYY/MM/DD HH:mm:ss');
                    }
                    if (this.staffForm.UpdateTime) {
                        this.staffForm.UpdateTime = utilsCommon.formatDate(this.staffForm.UpdateTime, 'YYYY/MM/DD HH:mm:ss');
                    }
                    contestantServices.editUnitTeamLeader(this.staffForm).then(resData => {
                        console.log(resData);
                        if (resData.code == 0) {
                            this.$message.success(resData.data);
                            this.athleteDialogVisible = false;
                            this.getUnitTeamLeaders();
                        }
                    });

                    this.staffDialogVisible = false;
                } else {
                    this.$message.error('请完善表单信息');
                    return false;
                }
            });


        },
        submitTemaForm() {
            this.$refs.teamFormRef.validate(valid => {
                if (valid) {
                    if (!this.teamForm.AthleteIdList) {
                        this.$message.warning('请设置团队队员');
                        return;
                    }

                    let unit = this.$store.state.unitInfo;
                    if (unit) {
                        this.teamForm.UnitId = unit.UnitId;
                        this.teamForm.AccountId = unit.AccountId;
                    }

                    contestantServices.editUnitTeam(this.teamForm).then(resData => {
                        if (resData.code == 0) {
                            this.$message.success(resData.data);
                            this.teamDialogVisible = false;
                            this.getUnitTeams();
                        }
                    })


                }
            });
        },
        beforePhotoUpload(file) {
            const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 5;

            if (!isJPGOrPNG) {
                this.$message.error('照片只能是JPG或PNG格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('照片大小不能超过5MB!');
                return false;
            }
            return true;
        },
        beforeIdCardUpload(file) {
            const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 5;

            if (!isJPGOrPNG) {
                this.$message.error('身份证照片只能是JPG或PNG格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('身份证照片大小不能超过5MB!');
                return false;
            }
            return true;
        },
        beforeEnrollmentUpload(file) {
            const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 5;

            if (!isJPGOrPNG) {
                this.$message.error('学籍照片只能是JPG或PNG格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('学籍照片大小不能超过5MB!');
                return false;
            }
            return true;
        },
        uploadFile(options, fileType) {
            const file = options.file;
            const formData = new FormData();
            formData.append('files', file);
            formData.append('desc', 'unit-staff-files');
            formData.append('type', 'unit-staff-files');

            SystemService.uploadFiles(formData).then(res => {
                console.log(res);
                if (res.code == 0) {
                    if (fileType === 'athletePhoto') {
                        this.athleteForm.UserPhotoFileId = res.data[0].FileId;
                        this.athleteForm.UserPhotoFilePath = `unit-staff-files/${res.data[0].FileId}${res.data[0].FileSuffix}`;
                        this.$message.success('照片上传成功');
                    } else if (fileType === 'athleteIdCard') {
                        this.athleteForm.IdCardFileId = res.data[0].FileId;
                        this.athleteForm.IdCardFilePath = `unit-staff-files/${res.data[0].FileId}${res.data[0].FileSuffix}`;
                        this.$message.success('证件照片上传成功');
                    } else if (fileType == 'athleteEnrollment') {
                        this.athleteForm.EnrollmentFileId = res.data[0].FileId;
                        this.athleteForm.EnrollmentFilePath = `unit-staff-files/${res.data[0].FileId}${res.data[0].FileSuffix}`;
                        this.$message.success('学籍照片上传成功');
                    }
                    else if (fileType === 'staffPhoto') {
                        this.staffForm.StaffPhotoFileId = res.data[0].FileId;
                        this.staffForm.StaffPhotoFilePath = `unit-staff-files/${res.data[0].FileId}${res.data[0].FileSuffix}`;
                        this.$message.success('照片上传成功');
                    } else if (fileType === 'staffIdCard') {
                        this.staffForm.IdCardFileId = res.data[0].FileId;
                        this.staffForm.IdCardFilePath = `unit-staff-files/${res.data[0].FileId}${res.data[0].FileSuffix}`;
                        this.$message.success('证件照片上传成功');
                    } else if (fileType === 'teamPhoto') {
                        this.teamForm.TeamPhotoFileId = res.data[0].FileId;
                        this.teamForm.TeamPhotoFilePath = `unit-staff-files/${res.data[0].FileId}${res.data[0].FileSuffix}`;
                        this.$message.success('照片上传成功');
                    }
                }
            });
        },
        uploadStaffPhoto(options) {
            const file = options.file;
            // 在实际应用中，这里应该调用API上传文件
            // 现在我们使用FileReader模拟
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                this.staffForm.photoUrl = reader.result;
                this.staffForm.photo = file;
                this.$message.success('照片上传成功');
            };
        },
        uploadStaffIdCard(options) {
            const file = options.file;
            // 在实际应用中，这里应该调用API上传文件
            // 现在我们使用FileReader模拟
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                this.staffForm.idCardUrl = reader.result;
                this.staffForm.idCardImage = file;
                this.$message.success('身份证照片上传成功');
            };
        },
        handleDeleteRow(type, id) {
            // 实现删除运动员的逻辑
            this.$confirm('确认删除该记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                contestantServices.delUnitStaff({ type: type, id: id }).then(resData => {
                    if (resData.code == 0) {
                        this.$message.success(resData.data);
                        if (type == 'athlete') {
                            this.getUnitAthletes();
                        } else if (type == 'team_leader') {
                            this.getUnitTeamLeaders();
                        }
                    }
                });
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },


        handleAddTeam() {
            // 实现添加团队的逻辑
            if (this.checkUnit()) {
                this.dialogType = 'add';
                this.initAllAthleteList();
                this.resetTeamForm();
                this.teamDialogVisible = true;
            }
        },
        handleEditTeam(row) {
            console.log(row);

            // 实现编辑团队的逻辑
            this.dialogType = 'edit';
            this.initAllAthleteList();
            this.resetTeamForm();
            // 填充表单数据
            this.teamForm = {
                ...row,

            };
            this.teamDialogVisible = true;
        },

        resetTeamForm() {
            this.teamForm = {
                TeamId: '',
                AccountId: '',
                UnitId: '',
                TeamName: '',
                TeamPeopleNumber: 0,
                TeamGender: 0,
                TeamBoyPeopleNumber: 0,
                TeamGirlPeopleNumber: 0,
                AthleteIds: '',
                AthleteNames: '',
                TeamPhotoFileId: '',
                Remarks: ''
            };
            // 如果表单引用存在，重置验证
            if (this.$refs.teamFormRef) {
                this.$refs.teamFormRef.resetFields();
            }
        },
        // 格式化日期时间，移除ISO格式中的T
        formatDateTime(dateTime) {
            if (!dateTime) return '';
            // 替换字符串中的'T'为空格
            return utilsCommon.formatDate(dateTime, 'YYYY-MM-DD')
        },
        handlePreviewImage(url) {
            // 实现图片预览逻辑
            console.log('Preview image:', url);
        },
        handleDeleteImage(fileType) {
            // 实现图片删除逻辑
            if (fileType === 'athletePhoto') {
                this.athleteForm.UserPhotoFileId = '';
                this.athleteForm.UserPhotoFilePath = '';
            } else if (fileType === 'athleteIdCard') {
                this.athleteForm.IdCardFileId = '';
                this.athleteForm.IdCardFilePath = '';
            }
            else if (fileType === 'athleteEnrollment') {
                this.athleteForm.EnrollmentFileId = '';
                this.athleteForm.EnrollmentFilePath = '';
            } else if (fileType === 'staffPhoto') {
                this.staffForm.StaffPhotoFileId = '';
                this.staffForm.StaffPhotoFilePath = '';
            } else if (fileType === 'staffIdCard') {
                this.staffForm.IdCardFileId = '';
                this.staffForm.IdCardFilePath = '';
            } else if (fileType === 'teamPhoto') {
                this.teamForm.TeamPhotoFileId = '';
                this.teamForm.TeamPhotoFilePath = '';
            }
        }
    }
}
</script>

<style scoped>
.athlete-manage-container {
    width: 1400px;
    margin: 0 auto;
    background-color: #f0f2f5;
    min-height: calc(100vh - 40px);
}

.main-card {
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 20px;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.search-area {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    width: 100%;
}

.search-form {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.search-form .el-form-item {
    margin-bottom: 0;
    margin-right: 10px;
}

.search-box {
    width: 300px;
}

.search-btn {
    margin-left: 10px;
}

.card-header h3 {
    margin: 0;
    color: #303133;
    font-weight: 500;
    min-width: 120px;
}

.el-table {
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.el-tabs--border-card {
    border: none;
    box-shadow: none;
}

.el-tab-pane {
    padding: 20px;
}

.el-button {
    border-radius: 4px;
}

.el-button--small {
    padding: 8px 12px;
}

.el-button+.el-button {
    margin-left: 10px;
}

:deep(.el-tabs__header) {
    background-color: #fafafa;
    margin: 0;
}

:deep(.el-tabs__item) {
    height: 50px;
    line-height: 50px;
    font-size: 15px;
}

:deep(.el-tabs__item.is-active) {
    color: #409EFF;
    font-weight: bold;
}

/* 更新上传相关样式 */
.upload-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.avatar-uploader,
.id-card-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 180px;
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
}

.avatar-uploader:hover,
.id-card-uploader:hover {
    border-color: #409EFF;
}

.upload-placeholder {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #8c939d;
    width: 100%;
    height: 100%;
}

.upload-placeholder i {
    font-size: 28px;
    margin-bottom: 8px;
}

.avatar,
.id-card-image {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
}

.el-upload__tip {
    line-height: 1.4;
    text-align: center;
    width: 100%;
    color: #909399;
    font-size: 12px;
}

.el-divider {
    margin: 16px 0;
}

.el-divider__text {
    font-size: 16px;
    font-weight: 500;
    color: #303133;
}

.upload-item {
    margin-bottom: 30px;
}


:deep(.el-radio input[aria-hidden="true"]) {
    display: none !important;
}

:deep(.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner) {
    box-shadow: none !important;
}

:deep(.el-transfer__buttons button) {
    display: block !important;
    margin-left: 0px !important;
}

:deep(.el-transfer-panel) {
    width: 250px !important;
}

:deep(.el-transfer-panel__body) {
    height: 350px !important;
}

:deep(.el-upload--text) {
    padding: 45px 65px !important;
    box-sizing: border-box !important;
}

.image-delete {
    position: absolute;
    text-align: center;
    width: 30px;
    height: 30px;
    line-height: 30px;
    top: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 15px;
    color: red;
    cursor: pointer;
    display: none;
    font-size: 16px;
    z-index: 999;
}

.avatar-uploader:hover .image-delete,
.id-card-uploader:hover .image-delete {
    display: block;
}



.avatar,
.id-card-image {
    cursor: pointer;
}



/* 调整表格样式 */
:deep(.el-table) {
    /* 加深表格边框颜色 */
    --el-table-border-color: #DCDFE6;
    border-color: #DCDFE6;
}

:deep(.el-table td.el-table__cell),
:deep(.el-table th.el-table__cell) {
    /* 加深单元格边框颜色 */
    border-color: #DCDFE6;
}

:deep(.el-table__cell) {
    /* 加深文字颜色 */
    color: #303133;
}

:deep(.el-table__header-wrapper) {

    /* 加深表头背景色和文字颜色 */
    th.el-table__cell {
        background-color: #F5F7FA;
        color: #303133;
        font-weight: 600;
    }
}

/* 可选：鼠标悬停时的行背景色 */
:deep(.el-table__body tr:hover > td.el-table__cell) {
    background-color: #F5F7FA;
}
</style>
